// extracted by mini-css-extract-plugin
export default {"accordion_item":"styles_accordion_item__JV2hl"};